import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { api } from "../api";
import { Icon } from "./icons";
import { syncAppBadge } from "../lib/push";

// 右上の通知ベル。未読数バッジを表示し、定期的に更新（スマホでも押しやすい）。
export function NotificationBell() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let alive = true;
    const load = () => api.get<{ count: number }>("/notifications/unread-count")
      .then((d) => { if (alive) { setCount(d.count); syncAppBadge(d.count); } }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => { alive = false; clearInterval(t); window.removeEventListener("focus", onFocus); };
  }, []);

  return (
    <NavLink to="/notifications" className="relative p-1 text-gray-500 hover:text-brand-600" aria-label={`通知${count > 0 ? `（未読${count}件）` : ""}`}>
      <Icon name="bell" className="h-6 w-6" />
      {count > 0 && (
        <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </NavLink>
  );
}
